import { useQuery } from '@tanstack/react-query';
import { isPlatformAdmin } from '@pc/db';
import { useAuth } from '../auth/AuthProvider';

/**
 * Hook returning whether the signed-in user is a PeptideClients platform
 * admin. Resolves to false if not signed in. Cached for 5 minutes.
 */
export function usePlatformAdmin() {
  const { session } = useAuth();
  return useQuery({
    queryKey: ['platformAdmin', session?.user.id ?? null],
    queryFn: () => isPlatformAdmin(),
    enabled: Boolean(session),
    staleTime: 5 * 60_000,
  });
}
